import React from 'react';

import { SetupPaymentMethodsPageContent } from 'src/components/auth';
import { VerifierStaffAddPaymentMethodModal } from 'src/modals/billing';

export const SetupPaymentMethodsPage: React.FC = () => {
  return (
    <React.Fragment>
      <SetupPaymentMethodsPageContent />
      <VerifierStaffAddPaymentMethodModal />
    </React.Fragment>
  );
};
